import React from 'react';
import { AppModalContent } from '../../pages';
import type { OneStepInstallationModalLayoutProps } from './types';
import type { AppModalDisplayOptions } from '@wix/app-market-core-components-types';

export function OneStepInstallationModalLayout({
  appId,
  onClose,
  onLoad,
  onError,
  options = {},
  origin,
}: OneStepInstallationModalLayoutProps) {
  const {
    showReviews = false,
    showRating = true,
    hideAppPageLink = false,
  } = options;
  const showAppPageLink = !hideAppPageLink;
  const displayOptions: AppModalDisplayOptions = {
    showCtas: false,
    showHeader: false,
    showRating,
    showReviews,
    showPermissions: true,
    showStickyHeader: true,
    showPricingPlans: false,
    skin: 'slim',
    showTermsAndConditions: true,
    showAppPageLink,
  };

  return (
    <AppModalContent
      onClose={onClose}
      id={appId}
      onLoad={() => {
        onLoad?.();
      }}
      options={displayOptions}
      onError={onError}
      origin={origin}
    />
  );
}
